var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTvProgressIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14 28.5C21.732 28.5 28 22.232 28 14.5C28 6.76801 21.732 0.5 14 0.5C6.26801 0.5 0 6.76801 0 14.5C0 22.232 6.26801 28.5 14 28.5Z",
    fill: "#FF9800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 9.00065C5.52148 10.5315 4.83398 12.4382 4.83398 14.5007C4.83398 19.5607 8.94065 23.6673 14.0007 23.6673C19.0607 23.6673 23.1673 19.5607 23.1673 14.5007C23.1673 9.44065 19.0607 5.33398 14.0007 5.33398C12.6898 5.33398 11.434 5.60899 10.3065 6.11316",
    stroke: "#FF9800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.5547C12.8153 12.5547 11.8516 13.5185 11.8516 14.7031C11.8516 15.8878 12.8153 16.8516 14 16.8516C15.1847 16.8516 16.1484 15.8878 16.1484 14.7031C16.1484 13.5185 15.1847 12.5547 14 12.5547ZM14 15.9922C13.2892 15.9922 12.7109 15.4139 12.7109 14.7031C12.7109 13.9923 13.2892 13.4141 14 13.4141C14.7108 13.4141 15.2891 13.9923 15.2891 14.7031C15.2891 15.4139 14.7108 15.9922 14 15.9922Z",
    fill: "#FF9800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3584 14.4759C18.937 13.7996 16.7927 10.8359 14 10.8359C11.2079 10.8359 9.06302 13.7996 8.6416 14.4759L8.5 14.7031L8.6416 14.9304C9.06298 15.6066 11.2073 18.5703 14 18.5703C16.7921 18.5703 18.937 15.6067 19.3584 14.9304L19.5 14.7031L19.3584 14.4759ZM14 17.7109C11.8336 17.7109 10.0498 15.4389 9.52893 14.7028C10.0489 13.9661 11.8281 11.6953 14 11.6953C16.1662 11.6953 17.9499 13.967 18.4711 14.7035C17.9511 15.4402 16.1719 17.7109 14 17.7109Z",
    fill: "#FF9800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvProgressIcon);
export default __webpack_public_path__ + "static/media/tvProgressIcon.0cfc569e9834022bb04229d473935bca.svg";
export { ForwardRef as ReactComponent };